export const isProd = process.env.REACT_APP_API_ENV !== 'development'

export const phpPrefix = isProd ? 'https://pa18-pweb.pingan.com' : 'https://test-pa18-pweb.pingan.com'
export const docUrl = isProd ? 'https://smarttext.olatop.com/home' : 'http://smarttext.olatop-stg.paic.com.cn/home'

const url = {
  chances: '/newLottery/chances',
  myPrize: '/newLottery/mine',
  lottery: '/newLottery/draw',
  isSlideToUser: '/Slide/isSlideToUser',
  login: '/Login',
  captcha: '/Login/captcha',
  opt: '/Login/opt',
  imageCaptcha: '/Login/image',
  reloadImage: '/Login/reloadImage'
}

Object.keys(url).forEach(key => {
  url[key] = `${phpPrefix}${url[key]}`
})

export { url }

export const prizeList = {
  '-2': {
    wish: '您已参与过抽奖啦'
  },
  '-1': {
    imgIndex: 0,
    wish: '未中奖',
    desc: '很可惜，没中奖哦～',
    receive: '谢谢参与'
  },
  0: {
    imgIndex: 1,
    wish: '恭喜您',
    desc: '获得5元京东卡',
    receive: '中奖用户将在活动结束3日内收到短信，请及时查看'
  },
  1: {
    imgIndex: 2,
    wish: '恭喜您',
    desc: '获得30元水果券',
    receive: '中奖用户将在活动结束3日内收到短信，请及时查看'
  },
  2: {
    imgIndex: 3,
    wish: '恭喜您',
    desc: '获得抱枕被',
    receive: '中奖用户将在活动结束3日内收到短信，请及时查看'
  },
  3: {
    imgIndex: 4,
    wish: '恭喜您',
    desc: '获得坚果大礼包',
    receive: '中奖用户将在活动结束3日内收到短信，请及时查看'
  },
  4: {
    imgIndex: 5,
    wish: '恭喜您',
    desc: '获得iPhone14 Pro',
    receive: '中奖用户将在活动结束3日内收到短信，请及时查看'
  },
  5: {
    imgIndex: 6,
    wish: '恭喜您',
    desc: '获得文档处理百宝箱',
    receive: '文档还原、文档对比、文档抽取、文档审阅，人力成本降低70%，分析效率提升300%'
  }
}
